import type { PaymentGridsState } from './types';

export const getInitialPaymentGridsState = (): PaymentGridsState => ({
    publishedVersion: undefined,
    scenarios: {}
});
